import {List} from 'immutable';
import {registry} from 'records';
import {split, updateRepresentations} from './utils';

export function retrieved(state, action) {
  const {representations, resources} = split(action.data);

  return state
    .set('representations', updateRepresentations(
      state.get('representations'), representations, action.request))
    .setIn(['resources', action.request.uuid], resources)
    .setIn(['status', action.request.uuid], action.response.status);
}

export function deleted(state, action) {
  const {record} = action.request;
  const representations = state.get('representations');
  const resources = state.get('resources');
  const type = registry.typeFor(record);
  const nextRepresentations = representations.deleteIn([type, record.id.toString()]);
  const nextResources = resources.map((resource) => {
    return resource.update(type, (idList) => {
      const index = (idList) ? idList.indexOf(record.id.toString()) : -1;
      return (~index) ? idList.delete(index) : idList;
    });
  });

  return state
    .set('representations', nextRepresentations)
    .set('resources', nextResources)
    .setIn(['status', action.request.uuid], action.response.status);
}

export function created(state, action) {
  let nextState = state;
  const {resources: createdResources} = split(action.data);
  const {request: createdRequest} = action;

  nextState = nextState.updateIn(['resources'], (resources) => {
    return resources.map((resource, requestId) => {
      const request = state.getIn(['cache', requestId]);
      let retval = resource;

      const nextResource = resource.withMutations((mutableResource) => {
        createdResources.forEach((createdResource, type) => {
          if (!mutableResource.has(type)) {
            mutableResource.set(type, List());
          }
        });
      });

      if (request.url.join('/') === createdRequest.url.join('/')) {
        retval = nextResource.map((resourceList, type) => {
          const nextResourceList = resourceList
            .concat(createdResources.get(type, List()));

          return nextResourceList.toOrderedSet().toList();
        });
      }

      return retval;
    });
  });

  return nextState;
}

export function noContent(state, action) {
  return state
    .setIn(['status', action.request.uuid], action.response.status);
}

export function jobStatusTopic(state, action) {
  const jobStatusTopics = action.data['job-status-topics'] || [];

  let nextState = state;

  if (jobStatusTopics.length > 0) {
    nextState = nextState.updateIn(['jobs'], (jobs) => {
      jobStatusTopics.forEach((jobStatusTopic) => {
        jobs = jobs.set(jobStatusTopic.id, jobStatusTopic.set('id', parseInt(jobStatusTopic.id, 10)));
      });

      return jobs;
    });
  }

  return nextState;
}



// WEBPACK FOOTER //
// ./app/javascript/requests/reducers/updaters.js